import React, { useState, useEffect } from 'react'
import { Route } from 'react-router-dom'
import { Redirect } from 'react-router-dom'

const BACKEND_URL = process.env.REACT_APP_API_BASE
const ProtectedAdminRoute = ({ component: Component, ...rest }) => {
    const [user, setUser] = useState(null)
    const [authChecked, setAuthChecked] = useState(false)

    useEffect(() => {
        fetch(`${BACKEND_URL}/me`, { credentials: 'include' })
            .then((res) => res.json())
            .then((data) => {
                setUser(data)
                setAuthChecked(true)
            })
            .catch(() => {
                setUser(null)
                setAuthChecked(true)
            })
    }, [])

    return (
        <Route
            {...rest}
            render={(props) => {
                if (!authChecked)
                    return (
                        <div style={{ padding: '20px', textAlign: 'center' }}>
                            Checking authorization...
                        </div>
                    )
                if (!user) return <Redirect to="/admin" />
                return <Component {...props} />
            }}
        />
    )
}

export default ProtectedAdminRoute
